import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

type ContainerProps = {
  $isSetMinContainerHeight?: boolean;
};

export const Container = styled.div<ContainerProps>`
  position: relative;
  z-index: 1;

  ${props =>
    props.$isSetMinContainerHeight &&
    css`
      ${theme.breakpoints.only("mobile")} {
        block-size: 180px;
        margin-block-end: 20px;
      }

      ${theme.breakpoints.only("tablet")} {
        block-size: 270px;
        margin-block-end: 20px;
      }
    `}
`;

export const SlotContent = styled.div`
  line-height: 0;

  > div[id$="__container__"] {
    inline-size: 100%;

    text-align: center;
  }
`;
